export default __webpack_public_path__ + "static/media/disconnected.2cc7fc62.jpg";